import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  context: sessionStorage.getItem('saved_context') || 'LAB',
  friendlyId: null
};

export const contextSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    setContext: (state, { payload }) => {
      state.context = payload;
      sessionStorage.setItem('saved_context', payload);
    },
    resetContext: (state) => {
      state.context = 'LAB';
      sessionStorage.setItem('saved_context', 'LAB');
    },
    setFriendlyId: (state, action) => {
      state.friendlyId = action.payload;
    }
  }
});

export const contextActions = contextSlice.actions;
